// 금융권 구분: 은행(1금융) / 저축은행 / 신협 / 새마을금고 / 농·축협(상호금융)
export const TIERS = [['전체', 'common.all'], ['1금융', 'common.first'], ['저축은행', 'common.savingsBank'], ['신협', 'common.creditUnion'], ['새마을금고', 'common.mg'], ['농협', 'common.nh']];

const NH_BANK = /(농협은행|nh농협은행|nh은행)/i;
export function sectorOf(p) {
  if (p?.sector) return p.sector;
  const name = `${p?.bank || ''} ${p?.name || ''}`;
  if (/신협|신용협동조합/.test(name)) return 'cu';
  if (/저축은행/.test(name)) return 'savings';
  if (/새마을금고|mg새마을/i.test(name)) return 'mg';
  if (/(농협|축협|농축협)/.test(name) && !NH_BANK.test(name.replace(/\s/g, ''))) return 'nh';
  return p?.tier === '2금융' ? 'other' : 'bank';
}

export const sectorKey = p => ({ bank: 'common.first', savings: 'common.savingsBank', cu: 'common.creditUnion', mg: 'common.mg', nh: 'common.nh' }[sectorOf(p)] || 'common.second');

const TIER_SECTOR = { '1금융': 'bank', 저축은행: 'savings', 신협: 'cu', 새마을금고: 'mg', 농협: 'nh' };
// 지도 지점 필터: 선택한 금융권과 지점이 맞는지
export function matchesTier(place, tier) {
  if (!tier || tier === '전체') return true;
  if (TIER_SECTOR[tier]) return sectorOf(place) === TIER_SECTOR[tier];
  return place.tier === tier;
}
